export default class SecondaryNav {
  constructor($header) {
    this.$nav = $header.find('.js-header-secondary-nav');
  }

  init(user) {
    if (!this.$nav.length) {
      return;
    }

    this.showNav();

    this.setUserPicture(user);
  }

  showNav() {
    this.$nav.find('> .is-hidden').removeClass('is-hidden');
  }

    setUserPicture(user) {
      if (!(user && user.thumbnailUrl)) return;

    try {
      const $thumbnailWrapper = this.$nav.find('.js-header-user-thumbnail');
      const $userIcon = $thumbnailWrapper.find('svg');
      const $userPicture = $thumbnailWrapper.find('img');

      const picture = new Image();
      const avatarUrl = `/cdn-cgi/image/width=64,format=auto/profile/avatar/${user.id}`;

      picture.onload = () => {
        $userIcon.remove();
        $userPicture.attr({ src: avatarUrl });
      };

      picture.src = avatarUrl;
    } catch (e) {
      console.error('Couldn\'t set user picture', e);
    }
  }
}
